export enum LogoutSurface {
  LogoHold = 'logo-hold',
  TvRemote = 'tv-remote',
  Url = 'url'
}
